<template>
    <div>
        <modal :show.sync="pymeSales" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Fuente Captura de Información</h6>  
                <div class="row">
                    <div v-if="pymeMessage != null" class="alert alert-info">
                        <span>El valor actual del sistema es:<strong> {{ pymeMessage }}</strong></span>
                    </div>  
                    <p-button @click="saveSalesPymeData('Estados financieros')" type="block btn-warning">
                        <i slot="label" class="fa fa-cubes mr-3"></i>
                        Estados financieros
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveSalesPymeData('Software contable')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Software contable
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveSalesPymeData('Registros en excel')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Registros en excel
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveSalesPymeData('Libros contables')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Libros contables
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveSalesPymeData('Otros')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Otros
                    </p-button>
                </div>
                <template slot="footer">
                    <div class="left-side">
                        <p-button type="default" link @click="cancelAddRouteSales()">Cancelar</p-button>
                    </div>
                    <div class="divider"></div>
                    <div class="right-side">
                        
                    </div>
                </template>       
        </modal>
        <modal :show.sync="pymeCosts" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Fuente Captura de Información</h6>  
                <div class="row">
                    <p-button @click="saveCostsPymeData('Estados financieros')" type="block btn-warning">
                        <i slot="label" class="fa fa-cubes mr-3"></i>
                        Estados financieros
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Software contable')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Software contable
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Registros en excel')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Registros en excel
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Libros contables')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Libros contables
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Otros')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Otros
                    </p-button>
                </div>
                <template slot="footer">
                    <div class="left-side">
                        <p-button type="default" link @click="cancelAddRouteCosts()">Cancelar</p-button>
                    </div>
                    <div class="divider"></div>
                    <div class="right-side">
                        
                    </div>
                </template>       
        </modal>
        <card class="form-horizontal">
            <div class="card-header">
            </div>
            <div class="card-body text-center">
                <div class="row">
                    <p-button @click="toSalesData()" type="block btn-warning">
                        <i slot="label" class="fa fa-plus-square mr-3"></i>
                        Registrar ventas
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="toCostsData()" type="block btn-warning">
                        <i slot="label" class="fa fa-minus-square mr-3"></i>
                        Registrar costos
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="toRequestData()" type="block btn-default">
                        <i slot="label" class="fa fa-arrow-left mr-3"></i>
                        Volver
                    </p-button>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
    </div>
</template>
    <script>
    import { Card, Modal } from 'src/components/UIComponents'

    export default {
        components: {
            Card,
            Modal
        },
        data() {
            return {
                consumer: false,
                microcredit: false,
                pequenia_empresa: false,
                pymeSales: false,
                pymeCosts: false,
                pymeMessage: null
            }
        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setPymeSalesDescription (description) {
                this.$store.commit('updateCustomerPESales', description)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             setPymeCostsDescription (description) {
                this.$store.commit('updateCustomerPECosts', description)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveSalesPymeData (description) {
                this.setPymeSalesDescription(description);
                this.salesPath();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             saveCostsPymeData (description) {
                this.setPymeCostsDescription(description);
                this.costsPath();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddRouteSales () {
                this.pymeSales = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelAddRouteCosts () {
                this.pymeCosts = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             productValidator (product) {
                if (product.name.toLowerCase() == 'consumo') {
                    this.consumer = true;
                }
                else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                    this.microcredit = true;
                }
                else if (product.name.toLowerCase() == 'pequeña empresa') {
                    this.pequenia_empresa = true;
                }
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toRequestData() {
                this.$router.push('/asessments/new_asessment/customer/request_data');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesData() {
                if(this.pequenia_empresa) {
                    this.pymeSales = true;
                }
                else {
                    this.salesPath();
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            salesPath() {
                this.$router.push('/asessments/new_asessment/customer/sales');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            costsPath(){
                if (this.$store.state.isCustomer) {
                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                }
                else if(this.$store.state.isSpouse) {
                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                }
                else if(this.$store.state.isGuarantor) {
                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                }
                if (subcategory == 'general') {
                    if(!this.pequenia_empresa) {
                        this.$router.push('/asessments/new_asessment/customer/costs/business/general');
                    }
                    else {
                        this.$router.push('/asessments/new_asessment/customer/costs/business/pyme/general');
                        
                    }
                    
                }
                else if (subcategory == 'produccion') {
                    this.$router.push('/asessments/new_asessment/customer/costs_item_general_selection');
                }
                else if (subcategory == 'serviciogeneral') {
                    this.$router.push('/asessments/new_asessment/customer/costs/services/general');
                }
                else if (subcategory == 'transporte') {
                    if(!this.pequenia_empresa) {
                        this.$router.push('/asessments/new_asessment/customer/costs/services/transport');
                    }
                    else {
                        this.$router.push('/asessments/new_asessment/customer/costs/services/pyme-transport');
                        
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toCostsData() {
                if (this.$store.state.isCustomer) {
                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                }
                else if(this.$store.state.isSpouse) {
                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                }
                else if(this.$store.state.isGuarantor) {
                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                }
                if(this.pequenia_empresa && subcategory == 'general') {
                    this.$router.push('/asessments/new_asessment/customer/pyme_general_costs_selection');
                }
                else {
                    this.costsPath();
                }
            }
        },
        mounted(){
            if (this.$store.state.isCustomer) {
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType)
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].pe_sales || null;
                this.productValidator(product);   
            }
            else if(this.$store.state.isSpouse) {
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].productType)
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].pe_sales || null;
                this.productValidator(product);
            }
            else if(this.$store.state.isGuarantor) {
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].productType)
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].pe_sales || null;
                this.productValidator(product);
            }
        }
    }
</script>
<style>
</style>
